// extracted by mini-css-extract-plugin
export default {"custommodal":"modal_custommodal__5TjvB"};